import moment from 'moment';

const formatters = {
    cuit: (e) => {
        let first = e.substr(0, 2);
        let second = e.substr(2, 8);
        let third = e.substr(10, 1);
        return `${first}-${second}-${third}`;
    },
    sortStates: (a, b) => {
        if (a.id < b.id)
            return -1;
        if (a.id > b.id)
            return 1;
        return 0;
    },
    dateFormat: (value) => {
        if(value.trim() === '-') return value;
        try{
            let newValue = moment(value).format('DD/MM/YYYY');
            return newValue === 'Invalid date' ? value : newValue;
        }
        catch (e){
            console.log(e);
        }
        return value;
    },
    datetimeFormat: (value) => {
        if(value.trim() === '-') return value;
        try{
            let newValue = moment(value).format('DD/MM/YYYY hh:mm');
            return newValue === 'Invalid date' ? value : newValue;
        }
        catch (e){
            console.log(e);
        }
        return value;
    },
    intFormat: (value) => {
        if(!value || isNaN(parseInt(value, 10))) return value;
        if(!value) return value;
        return value.toLocaleString('de-DE', {maximumFractionDigits: 0});
    },
    floatFormat: (value) => {
        if(!value || isNaN(parseFloat(value))) return value;
        try {
            value = parseFloat(value);
            return value.toLocaleString('de-DE');
        }
        catch (e) {
            return value;
        }
    }
};

export default formatters;


// WEBPACK FOOTER //
// ./src/utils/formatters.js